
var urlParam = location.search.substring(1);

if (urlParam) {

  var param = urlParam.split('&');
  var paramArray = [];

  for (i = 0; i < param.length; i++) {
    var paramItem = param[i].split('=');
    paramArray[paramItem[0]] = paramItem[1];
  }

  if (paramArray.id == 'sogocareer') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(1).addClass('is-active');
    $('.tab-environment-content').eq(1).addClass('is-show');
  } else if (paramArray.id == 'sogoeducation') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(1).addClass('is-active');
    $('.tab-environment-content').eq(1).addClass('is-show');
  } else if (paramArray.id == 'kaigocareer') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(2).addClass('is-active');
    $('.tab-environment-content').eq(2).addClass('is-show');
  } else if (paramArray.id == 'kaigoeducation') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(2).addClass('is-active');
    $('.tab-environment-content').eq(2).addClass('is-show');
  } else if (paramArray.id == 'kaigo') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(2).addClass('is-active');
    $('.tab-environment-content').eq(2).addClass('is-show');
  } else if (paramArray.id == 'sogo') {
    $('.tab-environment-item').removeClass('is-active');
    $('.tab-environment-content').removeClass('is-show');
    $('.tab-environment-item').eq(1).addClass('is-active');
    $('.tab-environment-content').eq(1).addClass('is-show');
    $('.subtab-seminar-item').removeClass('is-active');
    $('.subtab-seminar-item').eq(1).addClass('is-active');
    $('.subtab-seminar-content').removeClass('is-show');
    $('.subtab-seminar-content').eq(1).addClass('is-show');
  } else if (paramArray.id == 'internship') {
    $('.tab-seminar-item').removeClass('is-active');
    $('.tab-seminar-internship').addClass('is-active');
    $('.tab-seminar-content').removeClass('is-show');
    $('.content__internship').addClass('is-show');
  }
}
